import { useEffect, useState } from "react";
import ReactPhoneInput from "react-phone-number-input";
import { isValidPhoneNumber, E164Number } from "libphonenumber-js";
import { InputProps } from "./Input";
import "react-phone-number-input/style.css";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface PhoneInputProps extends InputProps {
  country?: string;
  onValidityChange?: (valid: boolean) => void;
  className?: string;
  inputComponent?: React.ComponentType<React.InputHTMLAttributes<HTMLInputElement>>;
  value?: string;
  onSubmit: (value: string | string[]) => void;
}

const mapCountryToISO = (country?: string): "CA" | "US" => {
  switch ((country || "").toLowerCase()) {
    case "canada":
      return "CA";
    case "usa":
    case "us":
      return "US";
    default:
      return "CA";
  }
};

function PhoneInput(props: PhoneInputProps) {
  const [defaultCountry, setDefaultCountry] = useState<"CA" | "US">(mapCountryToISO(props.country));

  useEffect(() => {
    setDefaultCountry(mapCountryToISO(props.country));
  }, [props.country]);

  const handleChange = (value: string | E164Number | undefined) => {
    if (value) {
      const valid = isValidPhoneNumber(value);
      props.onValidityChange?.(valid);
      props.onSubmit(value as string);
    } else {
      props.onValidityChange?.(true);
      props.onSubmit("");
    }
  };

  return (
    <div className="max-w-md">
      <ReactPhoneInput
        id="phone"
        placeholder={props.placeholder || "Enter phone number"}
        value={props.value}
        onChange={handleChange}
        defaultCountry={defaultCountry}
        className={twMerge(
          clsx([
            `w-full p-2 border ${
              props.value && !isValidPhoneNumber(props.value) 
                ? "border-red-500" 
                : "border-gray-300"
            } rounded-md focus:ring-primary focus:border-primary`,
            props.className ?? ''
          ])
        )}
        inputComponent={props.inputComponent || undefined}
      />
      {props.value && !isValidPhoneNumber(props.value) && (
        <p className="text-sm text-red-600 mt-1">Invalid phone number</p>
      )}
    </div>
  );
}

export default PhoneInput;